import { SetStateAction, Dispatch } from "react";
import { Release } from "../schemas/release";
import { DisplayMode, TestStatus } from "../schemas/types";
import { formatDateUTC } from "../util";

export function StagingReleasesTable({
  mode,
  releaseValues,
  setReleaseValues,
}: {
  mode: DisplayMode;
  releaseValues: Release;
  setReleaseValues: Dispatch<SetStateAction<Release>>;
}) {
  let rows = [];
  if (!releaseValues.stagingReleases || releaseValues.stagingReleases.length === 0) {
    return null;
  }
  // Date after which NPM and CDN publish steps were separated.
  const isNewProcess =
    new Date(releaseValues.stagingReleases[0].date) > new Date("06/01/2022");
  if (mode === DisplayMode.DISPLAY) {
    rows = releaseValues.stagingReleases.map((stagingRelease) => {
      const testIcon =
        stagingRelease.testStatus === TestStatus.PASS
          ? "✅"
          : stagingRelease.testStatus === TestStatus.FAIL
          ? "❌"
          : "";
      const testLink = stagingRelease.testUrl ? (
        <a href={stagingRelease.testUrl}>{testIcon}</a>
      ) : (
        testIcon
      );
      const platformPublishCells = (
        <>
          <td>{stagingRelease.date ? "NPM" : ""}</td>
          <td>{stagingRelease.CDN ? "CDN" : ""}</td>
        </>
      );
      return (
        <tr key={stagingRelease.tag} className="staging-release-row">
          <td className="version">{stagingRelease.tag}</td>
          <td className="date">
            {formatDateUTC(new Date(stagingRelease.date))}
          </td>
          {isNewProcess && platformPublishCells}
          <td className={`test-status ${stagingRelease.testStatus || ""}`}>
            {testLink}
          </td>
        </tr>
      );
    });
  } else {
    rows = releaseValues.stagingReleases.map((stagingRelease, index) => {
      return (
        <tr key={index} className="staging-release-row">
          <td className="version">
            <input
              onChange={(e) =>
                setReleaseValues({
                  ...releaseValues,
                  stagingReleases: releaseValues.stagingReleases?.map(
                    (sr, i) => {
                      if (i === index) {
                        return { ...sr, tag: e.target.value };
                      }
                      return sr;
                    }
                  ),
                })
              }
              value={stagingRelease.tag || ""}
            />
          </td>
          <td className="date">
            <input
              onChange={(e) =>
                setReleaseValues({
                  ...releaseValues,
                  stagingReleases: releaseValues.stagingReleases?.map(
                    (sr, i) => {
                      if (i === index) {
                        return { ...sr, date: e.target.value };
                      }
                      return sr;
                    }
                  ),
                })
              }
              value={stagingRelease.date || ""}
            />
          </td>
          {isNewProcess && (<td width="40px">
            <input
              type="checkbox"
              onChange={(e) =>
                setReleaseValues({
                  ...releaseValues,
                  stagingReleases: releaseValues.stagingReleases?.map(
                    (sr, i) => {
                      if (i === index) {
                        return { ...sr, CDN: e.target.checked };
                      }
                      return sr;
                    }
                  ),
                })
              }
              checked={stagingRelease.CDN}
            />
          </td>)}
          <td width="40px">
            <select
              className="test-status"
              value={stagingRelease.testStatus || ""}
              onChange={(e) =>
                setReleaseValues({
                  ...releaseValues,
                  stagingReleases: releaseValues.stagingReleases?.map(
                    (sr, i) => {
                      if (i === index) {
                        stagingRelease.testStatus = e.target.value as
                          | TestStatus
                          | undefined;
                        return {
                          ...sr,
                          testStatus: e.target.value as TestStatus | undefined,
                        };
                      } else {
                        return sr;
                      }
                    }
                  ),
                })
              }
            >
              <option value="pass">✅</option>
              <option value="fail">❌</option>
              <option value="">n/a</option>
            </select>
          </td>
          <td>
            <button
              className="delete"
              onClick={() =>
                setReleaseValues({
                  ...releaseValues,
                  stagingReleases: releaseValues.stagingReleases?.filter(
                    (sr, i) => i !== index
                  ),
                })
              }
            >
              x
            </button>
          </td>
        </tr>
      );
    });
    rows.unshift(
      <tr key="headers">
        <td>Version</td>
        <td>Date</td>
        {isNewProcess && <td>CDN</td>}
        <td>E2E</td>
      </tr>
    );
    rows.push(
      <tr key="add">
        <td colSpan={3}>
          <button
            className="ok"
            onClick={() =>
              setReleaseValues({
                ...releaseValues,
                stagingReleases: (releaseValues.stagingReleases || []).concat({
                  tag: "",
                  date: ""
                }),
              })
            }
          >
            + add staging release
          </button>
        </td>
      </tr>
    );
  }
  return (
    <table className="staging-table">
      <tbody>{rows}</tbody>
    </table>
  );
}
